import {
  BasePopover,
  Button,
  Content,
  FillIcon,
  Flex,
  Heading,
  usePlatformProps,
} from '@acsbe/ui';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { BillingMethod } from '../../../context/BillingContext';
import { getPaymentMethodState } from './common';

type InvalidIconButtonProps = {
  card: BillingMethod;
  size?: 'lg' | 'md';
};

const Popover = styled(BasePopover)`
  max-height: unset;
`;

export const InvalidIconButton: FunctionComponent<InvalidIconButtonProps> = ({
  card,
  size = 'lg',
}) => {
  const { t } = useTranslation();
  const p = usePlatformProps();
  const {
    isInvalidCard,
    billingHasLicenses,
    isZipInvalid,
    isExpiredCard,
    isDeclinedCardOrExpiredCard,
  } = getPaymentMethodState(card);

  return (
    <Popover
      side="top"
      data-fit
      trigger={
        <Button
          variant="link"
          data-mixpanel="card-issue-details-billing"
          aria-label={`${t('BILLING_PAGE.INVALID_BUTTON_LABEL')}`}
        >
          <Content inline scale="danger" variant="element">
            <FillIcon size={size} name="ExclamationMarkWithCircle" />
          </Content>
        </Button>
      }
      {...p.uptoDesktopSm({
        align: 'start',
      })}
      {...p.uptoPhablet({
        align: 'center',
      })}
    >
      <Flex gap={4} align="start">
        <Flex gap={1} maxWidth="318px">
          <Heading level={2} size="xxs" emphasis="low">
            {isInvalidCard
              ? t('BILLING_PAGE.CARD_DECLINED_TITLE')
              : isExpiredCard
                ? t('BILLING_PAGE.CARD_EXPIRED_TITLE')
                : isZipInvalid
                  ? t('BILLING_PAGE.CARD_ZIP_INVALID_TITLE')
                  : null}
          </Heading>

          <Content variant="element">
            {isZipInvalid
              ? t('BILLING_PAGE.CARD_ZIP_INVALID_MESSAGE')
              : billingHasLicenses
                ? t('BILLING_PAGE.CARD_ERROR_MESSAGE_WITH_LICENSES')
                : t('BILLING_PAGE.CARD_ERROR_MESSAGE_WITHOUT_LICENSES')}
          </Content>
        </Flex>
      </Flex>
    </Popover>
  );
};
